"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIdleCallback = exports.cancelIdle = exports.requestIdle = exports.isIdleCallbackSupported = void 0;
const react_1 = require("react");
exports.isIdleCallbackSupported = typeof window !== 'undefined' && 'requestIdleCallback' in window;
function customRequestIdleCallback(callback, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
options) {
    const start = Date.now();
    return +setTimeout(() => {
        callback({
            didTimeout: false,
            timeRemaining() {
                return Math.max(0, 50 - (Date.now() - start));
            },
        });
    }, 1);
}
function customCancelIdleCallback(handle) {
    clearTimeout(handle);
}
exports.requestIdle = exports.isIdleCallbackSupported
    ? window.requestIdleCallback
    : customRequestIdleCallback;
exports.cancelIdle = exports.isIdleCallbackSupported
    ? window.cancelIdleCallback
    : customCancelIdleCallback;
function useIdleCallback(callback, called) {
    // Fallback for called state is to prevent double execution
    const calledFallbackRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(function preload() {
        if (called || calledFallbackRef.current)
            return;
        calledFallbackRef.current++;
        const idleId = (0, exports.requestIdle)(callback);
        return () => {
            (0, exports.cancelIdle)(idleId);
        };
    }, [called, callback]);
}
exports.useIdleCallback = useIdleCallback;
//# sourceMappingURL=RequestIdleCallback.js.map